import HttpCondominio from "@/typescript/servicos/http/condominio";
import { HttpRequestConfig } from "@/typescript/servicos/http/http.interfaces";
import { HelperLayoutE02Response, ILayoutE02Repositorio } from "./e02.repositorio.interface";
import { IRequestAtivarLayoutPorId, IRequestAtualizarLayout, IRequestCriarLayout, IRequestObterLayoutPorId, IRequestObterLayouts, IRequestRemoverLayoutPorId } from "./e02.repositorio.request";

export class LayoutE02Repositorio implements ILayoutE02Repositorio {
  http: HttpCondominio;

  constructor(http: HttpCondominio) {
    this.http = http;
  }

  async obterLayouts(data: IRequestObterLayouts, config?: HttpRequestConfig): HelperLayoutE02Response["ResponseObterLayouts"] {
    return this.http.get('/layout-parametrizado', { params: data, ...config });
  }

  async obterLayoutPorId({ layout_id }: IRequestObterLayoutPorId, config?: HttpRequestConfig): HelperLayoutE02Response["ResponseObterLayoutPorId"] {
    return this.http.get(`/layout-parametrizado/${layout_id}`, config);
  }

  async removerLayoutPorId({ layout_id }: IRequestRemoverLayoutPorId, config?: HttpRequestConfig): Promise<void> {
    await this.http.delete(`/layout-parametrizado/${layout_id}`, config);
  }

  async ativarLayoutPorId(data: IRequestAtivarLayoutPorId, config?: HttpRequestConfig): HelperLayoutE02Response["ResponseAtivarLayoutPorId"] {
    return this.http.patch('/layout-parametrizado', data, config);
  }

  async criarLayout(data: IRequestCriarLayout, config?: HttpRequestConfig): HelperLayoutE02Response["ResponseCriarLayout"] {
    return this.http.post('/layout-parametrizado', data, config);
  }

  async atualizarLayout(data: IRequestAtualizarLayout, config?: HttpRequestConfig): HelperLayoutE02Response["ResponseAtualizarLayout"] {
    return this.http.put('/layout-parametrizado', data, config);
  }
}